import { styled } from "styled-components";

export const WrapperInputCheck = styled.div`
  .form-check-input:checked {
    border: 1px solid rgb(124, 1, 255);
    background-color: rgb(124, 1, 255);
  }
`;
